import {
  setErrors,
  setInfoMessage,
  setWarningMessage,
} from "../store/alerts/alertsActions";
import { ApiResult } from "../models/ApiResult";
import { UNKNOWN_ERROR } from "./tryCatchRequest";
import { t } from "i18next";

export const dispatchAlerts = (
  response: ApiResult,
  dispatch: Function = () => {}
) => {
  if (response.isError) {
    return setErrors(response.errorTable ?? [t(UNKNOWN_ERROR)]);
  }

  switch (response.messageType) {
    case "info":
      if (response.errorTable.length > 0) {
        return setInfoMessage(response.errorTable);
      }
      break;
    case "error":
      return setErrors(response.errorTable);
    case "warning":
      return setWarningMessage(response.errorTable);
  }
};

export const onErroredResponse = (
  errors: string[],
  dispatch: Function = () => {}
) => {
  return setErrors(errors);
};
